import React from "react";
import classnames from "classnames";

const Input = React.forwardRef(
  ({ className, textColor, widthFull, onChange, ...props }, ref) => (
    <input
      data-testid={
        props["data-testid"] ? props["data-testid"] : "Input-testSelector"
      }
      className={classnames(`bg-transparent outline-none ${className}`, {
        "w-full": widthFull
      })}
      style={{ color: textColor }}
      ref={ref}
      onChange={onChange}
      {...props}
    />
  )
);

Input.defaultProps = {
  className: "",
  textColor: "",
  widthFull: true,
  onChange: () => {}
};

export default Input;
